
import { REQ } from "constants/api/requests"
import { enumTenant } from "constants/bonus"
import { IResponse, IResponsePayload } from "constants/interfaces"

import useApi, { cookies, setCookies } from "util/api"

import { IAuth, IAuthService, LoginResponse, LoginResponseDefault, LogoutResponse } from "./type"

class AuthService implements IAuthService {
  public async signIn(body: IAuth) {
    const { data } = await useApi.post<IResponsePayload<LoginResponse>>(REQ.AUTH.LOGIN, {
      ...body,
      tenantId: enumTenant.Blockbets
    })

    return data.response.payload
  }

  public async signInWithTwoFactor(two_fa_code: string) {
    const { data } = await useApi.post<IResponsePayload<LoginResponseDefault>>(REQ.AUTH.MFA_LOGIN, { two_fa_code })

    return data.response.payload
  }

  public async removeTwoFactorByRecoveryCode(recovery_code: string) {
    const { data } = await useApi.post<IResponse<{ disabled: boolean }>>(REQ.AUTH.MFA_REMOVE_BY_BACKUP, { recovery_code })

    return data.response
  }

  public async refreshToken(token: string) {
    const { data } = await useApi.get(REQ.AUTH.REFRESH, {
      headers: {
        Authorization: `Bearer ${token}`,
        _retry: true
      }
    })

    return data
  }

  public async logout(): Promise<void> {
    await useApi.get<IResponsePayload<LogoutResponse>>(REQ.AUTH.LOGOUT)
  }

  public registerAccessToken(token: string | string[]): void {
    if (typeof token === "string") {
      setCookies("tokens", { ...cookies, access_token: token })
    }
  }

  public registerRefreshToken(token: string | string[]): void {
    if (typeof token === "string") {
      setCookies("tokens", { ...cookies, refresh_token: token })
    }
  }
}

export const authService = new AuthService()
